const Selectors = {
};
class repairServiceJS {
    constructor() {
       this._lineScroll();
       document.querySelector('.repair-form #submit-ticket').addEventListener('click', event => {
           this._submitRepairTicket(event);
       });
    }

    _lineScroll(){
        document.addEventListener("DOMContentLoaded", function(){
            const tl = gsap.timeline()
            .to('.work-list-img', {
                color:'#cfd1d1',
                opacity: 1,
                ease: "none",
                duration: 1,
                stagger: 1.20
            }, 0)
            .to('.work-steps', {
                ease: "linear",
                duration: 1,
                stagger:1.15
            }, 0)
            .from('.bg-bar', {
                height: 0,
                ease: "linear",
                duration: 1,
                stagger: 1.15
            }, 1)

            const controller = new ScrollMagic.Controller();
            const scene = new ScrollMagic.Scene({
                triggerElement: '.how-it-works-container',
                triggerHook: .5,
                offset: 0,
                duration: document.querySelector('.how-it-works-container').clientHeight
            })
            .setTween(tl)
            // .addIndicators()
            .addTo(controller)

        });
    }

    _submitRepairTicket(event){
        event.preventDefault();
        const form = event.currentTarget.closest('form');
        const fullName = document.getElementById("repairuser-name").value;
        const email = document.getElementById("repairuser-email").value;
        const phoneInput = document.getElementById("repairuser-phone").value;
        const modelSelect = document.getElementById("repairuser-model").value;
        const aboutMessage = document.getElementById("repairuser-about").value;
        const messageTextarea = document.getElementById("repairuser-problem").value;
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const phonePattern = /^[0-9]{10}$/;

        form.querySelectorAll('.form-control').forEach(element => {
            var value_ = element.value;
            if (value_ == '' || value_ == undefined) {
                element.classList.add('please-fill');
            } else {
                element.classList.remove('please-fill');
            }
        });

        if (!emailPattern.test(email)) {
            document.getElementById("repairuser-email").classList.add('please-fill');
        } else if (!phonePattern.test(phoneInput)) {
            document.getElementById("repairuser-phone").classList.add('please-fill');
        } else {
            document.getElementById("repairuser-email").classList.remove('please-fill');
            document.getElementById("repairuser-phone").classList.remove('please-fill');
        }

        if (!document.querySelector('.please-fill')) {
            const body = JSON.stringify({
                fullname: fullName,
                email: email,
                phone: phoneInput,
                model: modelSelect,
                how: aboutMessage,
                problem: messageTextarea
            });

            fetch('https://app.dronenerds.com/api/ticket', { ...fetchConfig(), body })
            .then((response) => response.json())
            .then((data) => {
                document.querySelector('[data-repair-form]').classList.add('d-none');
                document.querySelector('.success_message').classList.remove('d-none');
                document.querySelector('.success_message [data-repair-success]').innerHTML = data.message;
            })
            .catch((e) => {
                console.error("ERROR",e);
            })
            .finally((e) => {
                setTimeout(() => {
                    form.reset();
                }, 1000);
            });
        }
    }
}

typeof repairServiceJS !== 'undefined' && new repairServiceJS();